import { useCallback, useEffect, useState } from 'react'
import { CloseLateralModalSimple, ModalMediumCenteredLoading } from '../../../../../../../../baseComponents/Modal'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import PaymentTypesAndSellsRegisterTPV from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/PaymentTypesRegisterTPV'
import { PaymentTypeModelTypeExtendedTPV } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import { getPaymentTypes } from '../../../../../../../../utils/reducers/getters'
import '../modalMoneyCashInOutTPVDSB.sass'


interface ModalPaymentTypesRegisterProps extends ModalPaymentTypesRegisterLogicProps {
    setOpenModal: SetEditDeleteModalTy
  
}

const ModalPaymentTypesRegister: React.FC<ModalPaymentTypesRegisterProps> = ({ setOpenModal, ...logic }) => {
    const { paymentTypesTPV } = useModalPaymentTypesRegisterLogic({...logic})

    return (
        <ModalMediumCenteredLoading loading={false} className='modal_payment_types_register ' opened={true} setOpened={() => setOpenModal(null)} onClickOut={true}>
            <CloseLateralModalSimple onClose={() => setOpenModal(null)} />
            <PaymentTypesAndSellsRegisterTPV paymentTypesTPV={paymentTypesTPV}  />
        </ModalMediumCenteredLoading>
    )
}

interface ModalPaymentTypesRegisterLogicProps {
    allRowData?: RowData
}

const useModalPaymentTypesRegisterLogic = ({ allRowData }: ModalPaymentTypesRegisterLogicProps) => {
    const [paymentTypesTPV, setPaymentTypesTPV] = useState<PaymentTypeModelTypeExtendedTPV[] | null>(null)
    const paymentTypes = getPaymentTypes()

    const getCashRegisterMoneysByPaymentTypes = useCallback(async () => {
        if (allRowData?.CashRegisterId) {
            const result = await twinFetchPostJSON('/api/app/order/tpv/cashRegister/cashRegisterMoney/getAllCashRegisterMoneyLogsByCashRegister', { where: { 'CashRegisterMoney.CashRegisterId': allRowData.CashRegisterId } })
            if (result) {
                const dictCashRegisterMoneys: TwinDictionary = {}
                for (const element of result) {
                    const cashRegisterMoney = element?.CashRegisterMoney
                    if (!dictCashRegisterMoneys?.[cashRegisterMoney.PaymentTypeId]) {
                        dictCashRegisterMoneys[cashRegisterMoney.PaymentTypeId] = { ...cashRegisterMoney, CashRegisterMoneyLogs: []}
                    }
                    delete element.CashRegisterMoney
                    dictCashRegisterMoneys[cashRegisterMoney.PaymentTypeId]['CashRegisterMoneyLogs'].push(element)
                    dictCashRegisterMoneys[cashRegisterMoney.PaymentTypeId].money = element.endMoney
                }
                const myResult: PaymentTypeModelTypeExtendedTPV[] =[]
                for (const key in paymentTypes?.activeTpv) {
                    const element = paymentTypes?.activeTpv[parseInt(key)]
                    if (element) {
                        myResult.push({ ...element, CashRegisterMoney: dictCashRegisterMoneys?.[element.id] })
                    }
                }
                setPaymentTypesTPV(myResult)
            }
        }
    }, [setPaymentTypesTPV, allRowData?.CashRegisterId, paymentTypes])

    useEffect(() => {
        getCashRegisterMoneysByPaymentTypes()
    }, [getCashRegisterMoneysByPaymentTypes])

    return { paymentTypesTPV }
}


export default ModalPaymentTypesRegister